



import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({
  name: "uc-header-logo"
})
export default class UcHeaderLogoComponent extends Vue {
  @Prop({ default: null })
  Lg: boolean;

  onClick(){
    this.$emit("onClick")
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/layouts/header/uc-header-logo.vue